import { AuditFilter, AuditLog, ListResult } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'
import { AuditLogRequestParams, singleSortQueryFromPaginatedRequestParams } from '../nm-types'

const BATCH_SIZE = 100

export class AuditApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  getAudit({
    entity,
    entityName,
    fromDate,
    operation,
    toDate,
    username,
    result,
    excludeDerived,
    parentOperationId,
    ...params
  }: AuditLogRequestParams): Promise<ListResult<AuditLog>> {
    const filter: AuditFilter = {
      entity,
      entityName,
      fromDate: fromDate as unknown as Date,
      operation,
      result,
      toDate: toDate as unknown as Date,
      username,
      excludeDerived: excludeDerived === 'true',
      parentOperationId,
    }
    const query = singleSortQueryFromPaginatedRequestParams({ filter, paginatedRequestParams: params })
    return this.edgeClient.listAuditLogs(query)
  }

  /**
   * Fetches all derived operations for a given parent operation ID
   * @param parentOperationId - The parent operation to fetch children for
   * @returns All derived audit log entries for the parent
   */
  async getAllDerivedOperations(parentOperationId: string): Promise<AuditLog[]> {
    const firstPage = await this.getAudit({
      parentOperationId,
      pageNumber: '0',
      rowsPerPage: String(BATCH_SIZE),
    })

    const allItems: AuditLog[] = [...firstPage.items]
    const numPages = Math.ceil(firstPage.total / BATCH_SIZE)

    for (let page = 1; page < numPages; page++) {
      const result = await this.getAudit({
        parentOperationId,
        pageNumber: String(page),
        rowsPerPage: String(BATCH_SIZE),
      })
      allItems.push(...result.items)
    }

    return allItems
  }
}
